import { useState } from 'react';
import Modal from '../ui/Modal';

const PrivacyPolicy = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button 
        onClick={() => setIsOpen(true)}
        className="hover:text-red-500 transition-colors duration-300"
      >
        Integritetspolicy
      </button>
      
      <Modal 
        isOpen={isOpen} 
        onClose={() => setIsOpen(false)}
        title="Integritetspolicy"
      >
        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-bold mb-4">1. Introduktion</h2>
            <p className="mb-4">
              RenGlans Städtjänster AB värnar om din integritet och är engagerade i att skydda dina personuppgifter. Denna integritetspolicy förklarar hur vi samlar in, använder och skyddar dina personuppgifter i enlighet med GDPR (Dataskyddsförordningen).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">2. Vilka uppgifter samlar vi in?</h2>
            <p className="mb-4">Vi kan samla in följande typer av information:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Kontaktinformation (namn, adress, e-post, telefonnummer)</li>
              <li>Information om dina städtjänster och preferenser</li>
              <li>Kommunikation mellan dig och vår kundtjänst</li>
              <li>Formulärdata som lagras i säkra molntjänster från Google för bokhantering</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">3. Hur vi använder dina uppgifter</h2>
            <p className="mb-4">Dina personuppgifter kan användas för att:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Genomföra våra åtaganden gentemot dig som kund</li>
              <li>Hantera dina bokningar och betalningar</li>
              <li>Skicka viktig information om dina tjänster via e-post</li>
              <li>Lagra formulärdata i säkra molntjänster från Google för effektiv bokhantering</li>
              <li>Förbättra våra tjänster och kundupplevelse</li>
              <li>Uppfylla lagliga krav och förpliktelser</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">4. Rättigheter enligt GDPR</h2>
            <p className="mb-2">Enligt GDPR har du rätt till:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Rätt till tillgång till dina personuppgifter</li>
              <li>Rätt att få felaktiga uppgifter rättade</li>
              <li>Rätt att begära radering av dina uppgifter</li>
              <li>Rätt att invända mot vissa användningar av dina uppgifter</li>
              <li>Rätt till dataportabilitet</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">5. Dataskydd och tredjepartstjänster</h2>
            <p className="mb-4">
              Vi vidtar lämpliga tekniska och organisatoriska åtgärder för att skydda dina personuppgifter mot oavsiktlig eller olovlig förstöring, förlust eller ändring, obehörig utlämnande eller tillgång.
            </p>
            <p className="mb-4">
              <strong>Tredjepartsbehandling:</strong> Vi använder säkra molntjänster från Google för att lagra formulärdata. Google agerar som databehandlare och skyddar dina uppgifter enligt GDPR. Data överförs säkert och lagras på Googles servrar inom EU/EES.
            </p>
            <p className="mb-4">
              <strong>Datalagringstid:</strong> Dina uppgifter sparas i våra molntjänster i 2 år från sista kontakt, därefter raderas de regelbundet.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">6. Uppdateringar av policyn</h2>
            <p className="mb-4">
              Vi kan komma att uppdatera denna integritetspolicy. Eventuella ändringar publiceras på vår webbplats. Genom att fortsätta använda våra tjänster efter att ändringarna trätt i kraft godkänner du den uppdaterade policyn.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">7. Kontakt</h2>
            <p>
              För frågor om vår integritetspolicy eller vår behandling av dina personuppgifter, kontakta vår dataskyddsombud på <a href="mailto:dataskydd@renglans.se" className="text-red-600 hover:underline">dataskydd@renglans.se</a>.
            </p>
          </section>
          
          <p className="text-sm text-gray-500 mt-8">Senast uppdaterad: 16 december 2025</p>
        </div>
      </Modal>
    </>
  );
};

export default PrivacyPolicy;
